export class ApiBaseClient {
	public static API_VERSION = '/client/v2' as const;

	protected get baseUri() {
		return [ApiBaseClient.API_VERSION, this.endpoint].filter(Boolean).join('/');
	}

	constructor(private readonly endpoint?: string) {
		// Empty
	}
}
